import Reflux from 'reflux';

const IndicatorActions = Reflux.createActions([
  'replace',
  'append',
  'remove',
  'clear',
  'undo',
]);

export default IndicatorActions;



// WEBPACK FOOTER //
// ./app/actions/indicatorActions.jsx